import { useEffect } from 'react';
import { clearArticleQuantityCache } from '~/common/articleQuantityStorageClient.client.ts';
import { useLoginInfo } from '~/shell/hooks/useLoginInfo';

export function useAuthCleanup() {
  const { sessionId } = useLoginInfo();

  useEffect(() => {
    if(sessionId) {
      const currentSessionId = sessionStorage.getItem("sessionId");
      if(currentSessionId) {
        if(currentSessionId !== sessionId) {
          clearArticleQuantityCache();
        }
      }
      sessionStorage.setItem("sessionId", sessionId);
    } else {
      clearArticleQuantityCache();
    }
  }, [sessionId]);
}